<template>
  <el-container class="view-content">
    <el-header class="header-content">
      <el-form :model="searchItem" label-width="auto" inline size="small">
        <el-form-item label="上传时间">
          <date-picker v-model="searchItem.create_at" type="before" width="170px"></date-picker>
        </el-form-item>
        <el-form-item label="设备型号">
          <el-input v-model.trim="searchItem.model" clearable></el-input>
        </el-form-item>
        <el-form-item label="固件版本">
          <el-input v-model.trim="searchItem.sversion" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="space-between" align="middle">
        <statistics :count-list="countList"/>
        <el-button-group>
          <el-button type="primary" @click="add" size="small">上传固件</el-button>
        </el-button-group>
      </el-row>
    </el-header>
    <el-main class="main-content">
      <vue-table :table-data="tableData">
        <template slot="actionBar">
          <el-table-column align="center" label="操作栏" :resizable="false" width="100">
            <template slot-scope="scope">
              <!--修改-->
              <el-button type="text" @click="revise(scope.row)">修改</el-button>
              <!--禁用-->
              <el-button class="danger" type="text" @click="remove(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </template>
      </vue-table>
    </el-main>
    <el-footer class="footer-content">
      <vue-pagination :paging-data="pagingData" @table-reload="getTableList" ref="paging"></vue-pagination>
    </el-footer>
    <firmware-operate v-if="firmwareOperate.visible" :dialog-data="firmwareOperate" @table-reload="getTableList" />
  </el-container>
</template>

<script>
  import {PagingData} from "@mixins"
  import FirmwareOperate from "./dialog/FirmwareOperate"
  import DatePicker from '@view/components/date/DatePicker'
  import Statistics from "@view/components/Statistics"
  export default {
    name: "firmwareList",
    mixins: [PagingData],
    components: {FirmwareOperate, DatePicker, Statistics},
    data() {
      return {
        // 查询项
        searchItem: {
          model: "",
          sversion: "",
          create_at: ""
        },
        commitItem: null,
        // 统计
        countList: [
          {name: "固件总数", count: 0},
        ],
        // 表格数据
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "上传时间", property: "create_at"},
            {label: "设备型号", property: "model"},
            {label: "固件版本", property: "sversion"},
            {label: "备注", property: "remark"},
            {label: "上传者", property: "user.name"}
          ]
        },
        firmwareOperate: {
          title: "",
          visible: false,
          row: null,
        },
      }
    },
    methods: {
      add() {
        this.firmwareOperate.visible = true;
        this.firmwareOperate.title = "上传固件";
        this.firmwareOperate.row = null;
      },
      revise(row) {
        this.firmwareOperate.visible = true;
        this.firmwareOperate.title = "修改固件";
        this.firmwareOperate.row = row;
      },
      remove(row) {
        this.openConfirm("删除该固件", async ()=> {
          let nv = {};
          nv.optionId = row.id;
          let res = await this.$Http.deleteFirmware(nv);
          if (res) {
            this.msgSuccess("删除成功");
            this.$refs["paging"].removeFinish(1);
            this.getTableList();
          }
        });
      },
      // 查询
      search() {
        this.commitItem = {...this.searchItem};
        this.pagingData.currentPage = 1;
        this.getTableList();
      },
      // 获取列表
      async getTableList() {
        let nv = {
          page: this.pagingData.currentPage,
          limit: this.pagingData.pageSize
        };
        // 添加筛选项
        this.copyObjValue(nv, this.commitItem);
        let res = await this.$Http.getFirmwareList(nv);
        if (res?.data) {
          let total = +res.data.total || 0;
          this.pagingData.total = total;
          this.countList[0].count = total;
          this.tableData.tableList = this.getArray(res.data.list);
        }
      }
    },
    created() {
      this.getTableList();
    }
  }
</script>

<style scoped>

</style>
